module.exports = __webpack_public_path__ + "img/张长河@2x.2b5b2d50.png";